import { useQuery } from '@tanstack/react-query'
import { fetchElitePricingDetails, selectElitePricingDetails } from '../../../repository/misc'

async function fetchPricingDetailsOrThrow(): Promise<{ data?: unknown }> {
  const response = await fetchElitePricingDetails()
  // Backend can return 2xx with an error envelope — surface it as a query error so the sheet shows its error state
  if (!selectElitePricingDetails(response)) {
    throw new Error('Invalid elite pricing details response')
  }
  return response
}

/** Fetches Elite slab pricing when the lock-in pricing-details sheet opens. */
export function useElitePricingDetails(open: boolean) {
  return useQuery({
    queryKey: ['ELITE_PRICING_DETAILS'],
    queryFn: fetchPricingDetailsOrThrow,
    select: selectElitePricingDetails,
    enabled: open,
    retry: 1,
    refetchOnWindowFocus: false
  })
}
